import { createWorkerStore, WorkerStore } from '@enter/core';

export { WorkerStore, createWorkerStore } from '@enter/core';
export type { WorkerSelectionType, WorkerStoreOptions } from '@enter/core';

export default createWorkerStore({ readOnly: false, apiMode: 'provider' });
